(() => {
  function init(container = document) {
    const roots = [...container.querySelectorAll('[data-chakra-guide]')];
    if (container.matches?.('[data-chakra-guide]')) roots.unshift(container);
    roots.forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const tabs = [...root.querySelectorAll('[data-chakra-index]')];
      const panels = [...root.querySelectorAll('[data-chakra-panel]')];
      function activate(index, focus = false) {
        tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;});
        panels.forEach((panel, i) => {panel.hidden = i !== index;});
        if (focus) tabs[index]?.focus();
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(i));
        tab.addEventListener('keydown', event => {
          const destination = {ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1}[event.key];
          if (destination !== undefined) {event.preventDefault();activate(destination, true);}
        });
      });
      root.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-chakra-panel]');
        if (panel) activate(Number(panel.dataset.chakraPanel));
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
